/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BandingSetupDTO, BandingSetupResponse } from '../models/BandingSetupDTO';
import type { BandingSetupListRequestDto } from '../models/BandingSetupListRequestDto';
import type { BandingSetupListResponseDto } from '../models/BandingSetupListResponseDto';
import { request as __request } from '@openapi/request';

export class BandingSetupService {

    /**
     * @param requestBody
     * @returns BandingSetupDTO Saved Banding record successfully
     * @throws ApiError
     */
    public static async saveBandingSetup(
        requestBody: BandingSetupDTO,
    ): Promise<BandingSetupDTO> {
        const result = await __request({
            method: 'POST',
            path: `/web/api/production-bonus-setup/banding-setup/save`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns BandingSetupListResponseDto Extracted Banding record list successfully
     * @throws ApiError
     */
    public static async getBandingSetupList(
        requestBody: BandingSetupListRequestDto,
    ): Promise<BandingSetupListResponseDto> {
        const result = await __request({
            method: 'POST',
            path: `/web/api/production-bonus-setup/banding-setup/list`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static async bandingSetupImportCsv(
        requestBody: any,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/web/api/production-bonus-setup/banding-setup/import-csv`,
            formData: requestBody,
        });
        return result.body;
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static async exportCsvData(): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/web/api/production-bonus-setup/banding-setup/export-csv`,
        });
        return result.body;
    }


    /**
     * Delete a banding record by its OID.
     *
     * @param bandOid - Unique identifier of the banding record to delete
     * @returns BandingSetupResponse
     * @throws ApiError
     */
    public static async deleteBandingRecord(bandOid: string): Promise<BandingSetupResponse> {
        const result = await __request({
            method: 'DELETE',
            path: `/web/api/production-bonus-setup/banding-setup/${bandOid}`,
        });
        return result.body as BandingSetupResponse;
    }

}